import styled from "styled-components";

export const Wrapper = styled.div`
.widget-grid { display: grid; grid-template-columns: 1fr; gap: 16px;}
.widget-card { background: #fff; border-radius: 16px; padding: 16px; box-shadow: 0 2px 6px rgba(0,0,0,0.1); }
.widget-value { font-size: 14px; font-weight: bold; }
.widget-title { font-size: 14px; font-weight: 600; }
.title { font-size: 18px; font-weight: 600; }
.flex-between { display: flex; justify-content: space-between; align-items: center; }
.column { display: flex; flex-direction: column; gap: 16px; }
.gap {height: 20px;}
`;
